module.exports = __webpack_public_path__ + "static/media/daisy-ridley-lesb.5612984e.jpg";